module.exports = __webpack_public_path__ + "static/media/IMG_6560-min.fb2d8bc9.JPG";